import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '@/pages/LoginPage';
import DashboardLayout from '@/components/DashboardLayout';
import Dashboard from '@/pages/Dashboard';
import Readiness from '@/pages/Readiness';
import PreStocktake from '@/pages/PreStocktake';
import RosterAreas from '@/pages/RosterAreas';
import DevicePool from '@/pages/DevicePool';
import Checklist from '@/pages/Checklist';
import Attendance from '@/pages/Attendance';
import Miscounts from '@/pages/Miscounts';
import Verifications from '@/pages/Verifications';
import AdminCutoff from '@/pages/AdminCutoff';
import TopStock from '@/pages/TopStock';
import Settings from '@/pages/Settings';
import Scheduling from '@/pages/Scheduling';
import StoreMap from '@/pages/StoreMap';
import { Toaster } from '@/components/ui/sonner';
import { loadPagePermissionsFromDB, clearPermissionsCache } from '@/utils/permissions-config';
import '@/App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = React.createContext(null);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => res.json())
        .then(async (data) => {
          if (data.id) {
            setUser(data);
            // Load page permissions from database
            await loadPagePermissionsFromDB(token);
          } else {
            localStorage.removeItem('token');
          }
        })
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
    // Load page permissions from database after login
    await loadPagePermissionsFromDB(token);
  };

  const logout = () => {
    localStorage.removeItem('token');
    clearPermissionsCache();
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="text-slate-600">Loading...</div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={user ? <Navigate to="/" /> : <LoginPage />}
          />
          <Route
            path="/"
            element={user ? <DashboardLayout /> : <Navigate to="/login" />}
          >
            <Route index element={<Dashboard />} />
            <Route path="readiness" element={<Readiness />} />
            <Route path="scheduling" element={<Scheduling />} />
            <Route path="pre-stocktake" element={<PreStocktake />} />
            <Route path="roster-areas" element={<RosterAreas />} />
            <Route path="device-pool" element={<DevicePool />} />
            <Route path="checklist" element={<Checklist />} />
            <Route path="store-map" element={<StoreMap />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="miscounts" element={<Miscounts />} />
            <Route path="verifications" element={<Verifications />} />
            <Route path="admin-cutoff" element={<AdminCutoff />} />
            <Route path="top-stock" element={<TopStock />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthContext.Provider>
  );
}

export default App;
